module.exports = __webpack_public_path__ + "static/media/stack-of-photos.e16998ed.png";